import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { PeriodTypeService } from '../proxy/controlling/controllers/period-type.service';

FieldBuilder.setNamespace('Controlling');

export const PERIOD_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Period.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .number('month', 'Entity.Period.Month')
    .required()
    .build(),
  FieldBuilder
    .number('year', 'Entity.Period.Year')
    .required()
    .prefilter({
      defaultMode: 'equal',
      order: 2,
      emptyDisplayValueKey: 'LanguageService::ZnAll',
    })
    .build(),
  FieldBuilder
    .date('stockStartDate', 'Entity.Period.StockStartDate')
    .required()
    .equalOrLessThanField('stockEndDate', 'Controlling::Entity.Period.StockEndDate')
    .build(),
  FieldBuilder
    .date('stockEndDate', 'Entity.Period.StockEndDate')
    .required()
    .equalOrGreaterThanField('stockStartDate', 'Controlling::Entity.Period.StockStartDate')
    .build(),
  FieldBuilder
    .date('liquidationStartDate', 'Entity.Period.LiquidationStartDate')
    .required()
    .equalOrLessThanField('liquidationEndDate', 'Controlling::Entity.Period.LiquidationEndDate')
    .build(),
  FieldBuilder
    .date('liquidationEndDate', 'Entity.Period.LiquidationEndDate')
    .required()
    .equalOrGreaterThanField('liquidationStartDate', 'Controlling::Entity.Period.LiquidationStartDate')
    .build(),
  FieldBuilder
    .checkbox('isStockActive', 'Entity.Period.IsStockActive')
    .build(),
  FieldBuilder
    .checkbox('isLiquidationActive', 'Entity.Period.IsLiquidationActive')
    .build(),
  FieldBuilder
    .checkbox('isActivityReportIntegrationActive', 'Entity.Period.IsActivityReportIntegrationActive')
    .build(),
  FieldBuilder
    .checkbox('isMm4InterfaceActive', 'Entity.Period.IsMm4InterfaceActive')
    .build(),
  FieldBuilder
    .checkbox('isWoodValorizationClosed', 'Entity.Period.IsWoodValorizationClosed')
    .build(),
  FieldBuilder
    .foreignKey('periodTypeId', 'Entity.PeriodType', PeriodTypeService)
    .required()
    .displayFromNested('periodType.name')
    .sortBy('periodType.name')
    .prefilter({ order: 1 })
    .build(),
];

export const PERIOD_CONFIG = {
  entityName: 'Period',
  localizationKey: 'Controlling::Entity.Period',
  fields: PERIOD_FIELDS,
  permission: 'ControllingCalendar.Periods',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Calendar + MENU_NAME_SUFFIX,
};
